module.exports = __webpack_public_path__ + "assets/NotoSans-Medium.42b6fa652971de0a49b3df511da65245.ttf";